import { ROUTES } from '~constants/routes';
import { isManualChoice } from '~utils/flowChoice';

export const getStepNameByFlowChoice = clientFinancialInfo => flowChoice =>
  isManualChoice(flowChoice) && !clientFinancialInfo?.employmentSituation
    ? ROUTES.LETS_START.stepName
    : ROUTES.CLIENT_INCOMES.stepName;
